export default "__VITE_ASSET__ea3cd5c2__"